import { memo } from "react";

import { ProgressiveImage } from "@/components/progressive-image";

type ImageProps = {
  src: string;
  alt: string;
  width: number;
  height?: number;
  className?: string;
  fallback?: string;
  crc?: string;
  priority?: boolean;
  /** Responsive `sizes` hint — set it on fluid layouts to avoid over-fetching. */
  sizes?: string;
  /** `contain` fits the whole photo in the box on a white mat (product photos); `cover` crops to fill. */
  fit?: "cover" | "contain";
};

/**
 * Backwards-compatible alias for the repo-wide `<Image>` call sites. The real
 * implementation now lives in {@link ProgressiveImage}; this thin, memoized
 * wrapper preserves the original prop surface so existing callers keep working
 * unchanged. Prefer importing `ProgressiveImage` directly in new code — it also
 * exposes `sizes`, `quality`, `priority` preloading and responsive `srcset`.
 */
export const Image = memo(function Image({ fit, ...props }: ImageProps) {
  return <ProgressiveImage {...props} objectFit={fit} />;
});
